module.exports = __webpack_public_path__ + "img/bg.f81e9783.jpg";